import './css/site.css';
import 'jquery'
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import 'bootstrap';
import './css/bootstrap/bootstrap.scss';
import Vue from 'vue';
import VueFull from 'vuefull';
import Dropzone from 'dropzone';

//import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import ModuleComponent2 from './components/module/module';
import { createPinia, PiniaVuePlugin } from 'pinia';
import { WindowType } from './util';

declare var window: WindowType & any; // declare window for using global variables
window.Vue = Vue;
window.VueFull = VueFull;
window.Dropzone = Dropzone;

//Vue.use(VueRouter);
Vue.use(VueI18n);

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

const locale = window.application.locale;

// replace locale ts with runtime data
try { //does not work with andon
    locale.lang.de.txtActivityForwardText = locale.lang.de.txtActivityForwardText.replace("{0}", window.application.check2.RequestFlow);
    locale.lang.en.txtActivityForwardText = locale.lang.en.txtActivityForwardText.replace("{0}", window.application.check2.RequestFlow);
} catch (ex) { }

export const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'de',
    messages: locale.lang
})
if (window.application.culture !== undefined) {
    i18n.locale = window.application.culture; // change language based on razor lang variable
    console.log(window.application.culture);
}

const isDev = process.env.NODE_ENV !== "production";
console.log('Vue dev mode:', isDev);
Vue.config.devtools = isDev;
Vue.config.performance = isDev;

// webpack compiled components here
if (document.getElementById("app-root")) {
    new Vue({
        el: '#app-root',
        i18n,
        pinia,
        render: h => h(require('./components/Maintanence/ConfigUi/ConfigUi.vue').default)
    });
}

if (document.getElementById("app-root2")) {
    new Vue({
        el: '#app-root2',
        i18n,
        render: h => h(require('./components/home/home.vue.html').default)
    });
}

if (document.getElementById("account-manager")) {
    console.log("account-manager")
    new Vue({
        el: '#account-manager',
        i18n,
        render: h => h(require('./components/account/AccountEditor.vue').default)
    });
}

if (document.getElementById("account-selector")) {
    console.log("account-selector")
    new Vue({
        el: '#account-selector',
        i18n,
        render: h => h(require('./components/account/AccountSelect.vue').default)
    });
}

if (document.getElementById("activity-component")) {
    console.log("activity-component")
    new Vue({
        el: '#activity-component',
        i18n,
        pinia,
        render: h => h(require('./components/activity/Activities.vue').default)
    });
}

if (document.getElementById("calendar-component")) {
    console.log("calendar-component")
    new Vue({
        el: '#calendar-component',
        i18n,
        render: h => h(require('./components/calendar/calendar.vue.html').default)
    });
}

if (document.getElementById("activitylog-component")) {
    console.log("activitylog-component")
    new Vue({
        el: '#activitylog-component',
        i18n,
        render: h => h(require('./components/activitylog/activitylog.vue.html').default)
    });
}

if (document.getElementById("setup-component")) {
    console.log("setup-component")
    new Vue({
        el: '#setup-component',
        i18n,
        render: h => h(require('./components/setup/setup.vue.html').default)
    });
}

if (document.getElementById("info-component")) {
    console.log("info-component")
    const el = document.getElementById('info-component')!;
    let currentAccountName = el.getAttribute('data-account-name');
    new Vue({
        el: '#info-component',
        i18n,
        render: h => h(require('./components/infomodal/infomodal.vue').default,  { props: { currentAccountName } })
    });
}

if (document.getElementById("search-component")) {
    console.log("search-component")
    new Vue({
        el: '#search-component',
        i18n,
        render: h => h(require('./components/searchmodal/searchmodal.vue.html').default)
    });
}

if (document.getElementById("map-component")) {
    new Vue({
        el: '#map-component',
        i18n,
        render: h => h(require('./components/map/Page.vue').default),
        pinia,
    });
}

if (document.getElementById("downtimeinput-component")) {
    new Vue({
        el: '#downtimeinput-component',
        i18n,
        render: h => h(require('./components/event/event.vue.html').default)
    });
}

if (document.getElementById("report-component")) {
    new Vue({
        el: '#report-component',
        i18n,
        render: h => h(require('./components/reports/reports.vue.html').default)
    });
}

if (document.getElementById("reportcells-component")) {
    new Vue({
        el: '#reportcells-component',
        i18n,
        render: h => h(require('./components/reports/reportscells.vue.html').default)
    });
}

if (document.getElementById("reportoee-component")) {
    new Vue({
        el: '#reportoee-component',
        i18n,
        render: h => h(require('./components/reports/reportoee.vue.html').default)
    });
}

if (document.getElementById("reportoeecellshift-component")) {
    new Vue({
        el: '#reportoeecellshift-component',
        i18n,
        render: h => h(require('./components/reports/reportoeecellshift/reportoeecellshift.vue.html').default)
    });
}

if (document.getElementById("oeeconfig-component")) {
    new Vue({
        el: '#oeeconfig-component',
        i18n,
        render: h => h(require('./components/oeeconfigui/OeeConfigUi.vue').default)
    });
}

if (document.getElementById("monitoring-container")) {
    console.log("monitoring-container")
    new Vue({
        el: '#monitoring-container',
        i18n,
        render: h => h(require('./components/linechart/lccontainer.vue.html').default)
    });
}

if (document.getElementById("dashboard-saubermacher-container")) {
    console.log("dashboard-saubermacher-container")
    new Vue({
        el: '#dashboard-saubermacher-container',
        i18n,
        render: h => h(require('./components/dashboard_saubermacher/app/app.vue.html').default)
    });
}

if (document.getElementById("kanban-site")) {
    console.log("kanban-site");
    new Vue({
        el: '#kanban-site',
        i18n,
        pinia,
        render: h => h(require('./components/kanban/site/site.vue.html').default)
    });
}

if (document.getElementById("kanban-time-tracking")) {
    console.log("kanban-time-tracking");
    new Vue({
        el: '#kanban-time-tracking',
        i18n,
        render: h => h(require('./components/kanban/timetracking/TimeTrackingSite.vue').default)
    });
}

if (document.getElementById("kanbanpublic")) {
    console.log("kanbanpublic");
    let cardId = document.getElementById("kanbanpublic")?.dataset.cardid;
    new Vue({
        el: '#kanbanpublic',
        i18n,
        render: h => h(require('./components/kanban/public/Public.vue').default, { props: { cardId } })
    });
}

if (document.getElementById("organigram-page")) {
    console.log("organigram-page");
    new Vue({
        el: '#organigram-page',
        i18n,
        render: h => h(require('./components/organigramPage/organigramPage.vue.html').default)
    });
}

if (document.getElementById("testequipment-component")) {
    console.log("testequipment-component");
    new Vue({
        el: '#testequipment-component',
        i18n,
        pinia,
        render: h => h(require('./components/testequipment/main/TestEquipmentMain.vue').default)
    });
}

if (document.getElementById("andon")) {
    console.log("andon");
    let setting = document.getElementById("andon")?.dataset.setting;
    new Vue({
        el: '#andon',
        i18n,
        render: h => h(require('./components/andon/andon.vue.html').default, { props: { setting } })
    });
}

if (document.getElementById("andon-edit")) {
    console.log("andon-edit");
    new Vue({
        el: '#andon-edit',
        i18n,
        render: h => h(require('./components/andon/edit/edit.vue.html').default)
    });
}

if (document.getElementById("surveyjs")) {
    console.log("surveyjs");
    let surveyId = document.getElementById('surveyjs')?.dataset['surveyId'];
    let started = new Date(document.getElementById('surveyjs')?.dataset['started'] ?? new Date());
    new Vue({
        el: '#surveyjs',
        i18n,
        render: h => h(require('./components/survey/SurveyJSComponent.vue').default, { props: { surveyId, started } })
    });
}

if (document.getElementById("surveyjs-creator")) {
    console.log("surveyjs-creator");
    new Vue({
        el: '#surveyjs-creator',
        i18n,
        pinia,
        render: h => h(require('./components/survey/creator/Creator.vue').default)
    });
}

if (document.getElementById("survey-results")) {
    console.log("survey-results");
    let surveyId = document.getElementById('survey-results')?.dataset['surveyId'];
    new Vue({
        el: '#survey-results',
        i18n,
        render: h => h(require('./components/survey/results/Results.vue').default, { props: { surveyId } })
    });
}


if (document.getElementById("survey-results-combined")) {
    console.log("survey-results-combined");
    let groupId = document.getElementById('survey-results-combined')?.dataset['groupId'];
    new Vue({
        el: '#survey-results-combined',
        i18n,
        render: h => h(require('./components/survey/results/ResultsCombined.vue').default, { props: { groupId } })
    });
}

if (document.getElementById("survey-group-external-user-code")) {
    console.log("survey-group-external-user-code");
    new Vue({
        el: '#survey-group-external-user-code',
        i18n,
        render: h => h(require('./components/survey/code/Code.vue').default)
    });
}

if (document.getElementById("survey")) {
    console.log("survey");
    new Vue({
        el: '#survey',
        i18n,
        render: h => h(require('./components/survey/Overview.vue').default)
    });
}

if (document.getElementById("pivot-templates")) {
    console.log("pivot-templates");
    new Vue({
        el: '#pivot-templates',
        i18n,
        render: h => h(require('./components/pivot/templates/templates.vue.html').default)
    });
}

if (document.getElementById("pivot-translations")) {
    console.log("pivot-translations");
    new Vue({
        el: '#pivot-translations',
        i18n,
        render: h => h(require('./components/pivot/translations/Translations.vue').default)
    });
}

if (document.getElementById("tnt")) {
    console.log("tnt");
    new Vue({
        el: '#tnt',
        i18n,
        render: h => h(require('./components/tnt/Spa.vue').default)
    });
}

if (document.getElementById('dashboard')) {
    const dashboard = document.getElementById('dashboard')?.dataset.dashboard ?? '0/';
    const split = dashboard.split('/', 2);
    new Vue({
        el: '#dashboard',
        i18n,
        render: h => h(require('./components/dashboard/dashboard.vue').default, { props: { accountId: split[0], name: split[1] } }),
    });
}

if (document.getElementById('cbm-anonymous-duty')) {
    const cbmId = document.getElementById('cbm-anonymous-duty')?.dataset['cbmId'];
    if (cbmId) {
        new Vue({
            el: '#cbm-anonymous-duty',
            i18n,
            render: h => h(require('./components/cbm/AnonymousDuty.vue').default, { props: { cbmId: cbmId } }),
        });
    }
}

if (document.getElementById('links-configure')) {
    new Vue({
        el: '#links-configure',
        i18n,
        pinia,
        render: h => h(require('./components/links/Configure.vue').default),
    });
}

if (document.getElementById('links-show')) {
    const collectionId = document.getElementById('links-show')?.dataset['linkCollectionId'];
    if (collectionId) {
        new Vue({
            el: '#links-show',
            i18n,
            render: h => h(require('./components/links/Show.vue').default, { props: { collectionId: collectionId } }),
        });
    }
}

if (document.getElementById('actions-configure')) {
    new Vue({
        el: '#actions-configure',
        i18n,
        pinia,
        render: h => h(require('./components/actions/Configure.vue').default),
    });
}

if (document.getElementById('settings')) {
    new Vue({
        el: '#settings',
        i18n,
        pinia,
        render: h => h(require('./components/settings/Settings.vue').default),
    });
}

if (document.getElementById('contacts-configure')) {
    new Vue({
        el: '#contacts-configure',
        i18n,
        pinia,
        render: h => h(require('./components/revobase/contacts/Contacts.vue').default),
    });
}

if (document.getElementById("setup-ai")) {
    console.log("setup-ai")
    new Vue({
        el: '#setup-ai',
        i18n,
        render: h => h(require('./components/setup/AiSearch.vue').default)
    });
}

if (document.getElementById("accounts-config")) {
    console.log("accounts-config")
    let userId = document.getElementById("accounts-config")?.dataset.userId;
    new Vue({
        el: '#accounts-config',
        i18n,
        render: h => h(require('./components/revobase/users/AccountsButton.vue').default, { props: { userId: userId } }),
    });
}

if (document.getElementById("productQualityTests-component")) {
    console.log("productQualityTests-component");
    new Vue({
        el: '#productQualityTests-component',
        i18n,
        pinia,
        render: h => h(require('./components/productQualityTests/main/PqtMain.vue').default)
    });
}

if (document.getElementById('maintenance-overview2d')) {
    console.log('maintenance-overview2d');
    new Vue({
        el: '#maintenance-overview2d',
        i18n,
        pinia,
        render: h => h(require('./components/Maintanence/overview2d/Overview2d.vue').default),
    });
}

if (document.getElementById('visitor-management-check-in-out-scanner')) {
    console.log('visitor-management-check-in-out-scanner');
    new Vue({
        el: '#visitor-management-check-in-out-scanner',
        i18n,
        pinia,
        render: h => h(require('./components/visitorManagment/scanner/CheckInOutScanner.vue').default),
    });
}

if (document.getElementById('visitor-management-advance-registration')) {
    console.log('visitor-management-advance-registration');
    const groupSurveyExtensionId = document.getElementById('groupSurveyExtensionId')?.dataset.groupSurveyExtensionId;
    new Vue({
        el: '#visitor-management-advance-registration',
        i18n,
        pinia,
        render: h => h(require('./components/visitorManagment/advanceRegistration/AdvanceRegistration.vue').default, { props: { groupSurveyExtensionId: groupSurveyExtensionId } }),
    });
}

if (document.getElementById('visitor-management-advance-registration-approval-complete')) {
    console.log('visitor-management-advance-registration-approval-complete');
    const groupSurveyExtensionId = document.getElementById('visitor-management-advance-registration-approval-complete')?.dataset.groupSurveyExtensionId;
    const userId = document.getElementById('visitor-management-advance-registration-approval-complete')?.dataset.userId || null;
    const externalUserId = document.getElementById('visitor-management-advance-registration-approval-complete')?.dataset.externalUserId || null;
    const action = document.getElementById('visitor-management-advance-registration-approval-complete')?.dataset.action;
    new Vue({
        el: '#visitor-management-advance-registration-approval-complete',
        i18n,
        pinia,
        render: h => h(require('./components/visitorManagment/advanceRegistration/AdvanceRegistrationApprovalComplete.vue').default, {
            props: {
                groupSurveyExtensionId: groupSurveyExtensionId,
                userId: userId,
                externalUserId: externalUserId,
                action: action,
            },
        }),
    });
}

//
// dynamic binding components here
// showing dynamic binding
if (document.getElementById("testtypescriptmodule")) {
    console.log("trying vue module.ts");
    new VueFull(ModuleComponent2).$mount('#testtypescriptmodule'); // see https://codingexplained.com/coding/front-end/vue-js/mounting-templates-dynamically
}
else {
    console.log("couldnt find id testtypescriptmodule");
}

